import React, { createContext, useReducer } from 'react';

const initialState = {
  user: null,
};

const RootContext = createContext();

const rootReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, user: action.user };
    default:
      return state;
  }
};

const RootContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(rootReducer, initialState);

  return (
    <RootContext.Provider value={{ state, dispatch }}>
      {children}
    </RootContext.Provider>
  );
};

export { RootContext, RootContextProvider };
